import { Cloud } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <Link to={compact ? "/app/servers" : "/"} className={`brand ${compact ? "brand--compact" : ""}`} aria-label="Cloud 4smart.cz">
      <span className="brand__mark"><Cloud /></span>
      <span className="brand__name">cloud<span>.4smart.cz</span></span>
    </Link>
  );
}
